/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var CatMultiGraphicRecordAsset;
(function (CatMultiGraphicRecordAsset) {
    /**
     * The asset type
     */
    var type;
    (function (type) {
        type["PLAN_VIEW"] = "PlanView";
        type["_3DVIEW"] = "3DView";
        type["MGTR"] = "MGTR";
    })(type = CatMultiGraphicRecordAsset.type || (CatMultiGraphicRecordAsset.type = {}));
})(CatMultiGraphicRecordAsset || (CatMultiGraphicRecordAsset = {}));
